import React from 'react';
import clsx from 'clsx';
import styles from './Checkbox.module.scss';

const Checkbox = ({
  checked,
  onChange,
  disabled = false,
  variant = 'default',
  className,
  children,
  ...rest
}) => {
  return (
    <label
      className={clsx(
        styles.root,
        styles[variant],
        disabled && styles.disabled,
        className
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
        {...rest}
      />

      <span className={styles.control} />

      {children && (
        <span className={styles.label}>{children}</span>
      )}
    </label>
  );
};

export default Checkbox;
